module.exports = __webpack_public_path__ + "assets/img/cooperate.bfc5ba9e.png";